
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 800 356","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h195v32H0zM341 297h119v32H341zM0 49h521v18H0zM0 84h784v18H0zM0 154h466v18H0zM0 189h791v18H0zM0 224h209v18H0zM0 119h644v18H0z"}})])])
          )
        }
      }
    